module.exports = __webpack_public_path__ + "assets/src/style/img/svg/icons/category-my-list.svg?0332c0c1e0651a628250138d3461c256";